module.exports = __webpack_public_path__ + "img/10.7a872981.jpg";